import React from "react";
import { JOIN_US } from "../../intl/join-us";
import { useSelector } from "react-redux";

import Title from "../../components/Section/Section.Title";
import Section from "../../components/Section/Section";

const JoinUs = () => {
  const { lang, DASHBOARD_URL } = useSelector((state) => state.appReducer);
  const copy = JOIN_US[lang];

  return (
    <Section className="pb-20">
      <Title
        t1={copy.t1}
        t2={copy.t2}
        action={copy.action}
        href={DASHBOARD_URL}
      ></Title>
    </Section>
  );
};

export default JoinUs;
